Namespace 'Process'

class Process.ProcessExecutionListView extends Backbone.View
  template: JST["backbone/templates/process_execution_list"]

  initialize: (@options = {}) ->
    @collection = @options.collection
    @listenTo(@collection, 'add', @updateCount)
    @listenTo(@collection, 'destroy', @render)

  updateStatus: (processExecution) ->
    process = @_findProcess(processExecution.job_id)
    if process
      process.set(processExecution)
    else
      @prependProcess(processExecution)

  prependProcess: (processExecution) ->
    process = new Process.ProcessExecution(processExecution)
    @collection.add(process)
    @$el.find("tbody > tr:nth-child(1)").after new Process.ProcessExecutionView({model: process}).render().el

  updateProgress: (processExecution, updatedAmount) ->
    processExecution.completed_steps = updatedAmount
    @updateStatus(processExecution)

  _findProcess: (jobId) ->
    @collection.findWhere({job_id: jobId})

  updateCount: ->
    @$el.find('#download-count').text(@collection.length)

  render: ->
    @$el.html @template(count: @collection.length)
    @collection.each (model) =>
      @$el.find("tbody").append new Process.ProcessExecutionView({model: model}).render().el

class Process.ProcessExecutionView extends Backbone.View
  template: JST["backbone/templates/process_execution"]
  tagName: 'tr'

  events:
    'click .download': 'download'
    'click .cancel': 'cancel'
    'click .delete': 'delete'

  classes: {"Finished": "success", "Error": "danger", "Canceled": "secondary", "Pending": "secondary", "In progress": "info"}

  initialize: ->
    @listenTo(this.model, "change", this.render)
    @listenTo(this.model, "change:status", @setClass)
    @$el.addClass("canceled-status") if @model.attributes.status == "Canceled"

  render: ->
    @$el.html @template
      download: @model.attributes
      cancellable: @cancellable()
      downloadable: @downloadable()
      deletable: @deletable()
      remainingTime: @remainingTime()
      progressMessage: @progressMessage()
      progress: @progress()
      progressClass: @classes[@model.attributes.status]
      expirationDate: @expirationDate()
    @

  cancellable: ->
    @model.attributes.status in ['In progress', 'Pending']

  deletable: ->
    @model.attributes.status in ['Canceled', 'Error', 'Finished']

  downloadable: ->
    @model.attributes.status == 'Finished' && @model.attributes.file_path && !@isExpired()

  isExpired: ->
    if !@isExpirable()
      return false
    expirationDate = @expirationDate()
    expirationDate == '' ||  expirationDate < new Date()

  isExpirable: ->
    @model.attributes.report_key in ['monitoring_contents_report', 'customer_filters_report', 'users_report', 'surveys_report', 'profiles_report', 'cem_replies', 'contents', 'my_replies', 'tickets', 'conversations']

  cancel: ->
    @model.cancel()

  delete: ->
    swal({
      title: I18n.t('customer.reports.downloads.delete')
      text: I18n.t('customer.reports.downloads.delete_text')
      confirmButtonText: I18n.t('customer.reports.downloads.delete')
      cancelButtonText: I18n.t('customer.reports.downloads.cancel')
      type: "warning"
      showCancelButton: true
    }, => @model.delete())

  download: ->
    window.location = @model.attributes.file_path

  doDownload:(result)->
    window.location = result.file_path

  progress: ->
    if @model.attributes.status == "Finished"
      return 100

    if @model.attributes.steps > 0
      return Math.floor ((@model.attributes.completed_steps / @model.attributes.steps) * 100)

    return 0

  progressMessage: ->
    switch @model.attributes.status
      when "Canceled" then return I18n.t('customer.reports.downloads.canceled')
      when "Error" then return I18n.t('customer.reports.downloads.failed', { total: @model.attributes.steps })
      when "Finished" then return I18n.t('customer.reports.downloads.finished', { total: @model.attributes.steps })
      when "In progress" then return I18n.t('customer.reports.downloads.remaining_time',
        { time: @remainingTime(), exported: @model.attributes.completed_steps, total: @model.attributes.steps || 0 })
      when "Pending" then return I18n.t('customer.reports.downloads.pending')
      else return

  remainingTime: ->
    if @model.attributes.steps && @model.attributes.estimated_time_seconds
      remaining_seconds = @model.attributes.estimated_time_seconds -
        (@model.attributes.completed_steps / @model.attributes.steps) * @model.attributes.estimated_time_seconds
      duration = moment.duration(remaining_seconds, 'seconds')
      seconds = duration.seconds()
      minutes = duration.minutes()
      hours = duration.hours()
      remaining_time = hours + "h " + minutes + "m " + seconds + "s"
    else
      return "-"

  setClass: ->
    status = @model.attributes.status
    @$el.find("#progress").className = "text-" + @classes[status]
    @$el.find("#progress-bar").className = "progress-bar bg-" + @classes[status]
    @$el.addClass("canceled-status") if status == "Canceled"

  expirationDate: ->
    return '' unless @model.attributes.expiration_date
    new Date(@model.attributes.expiration_date)
